import type { components } from "@dolfin/api-admin";

type DeviceType = components["schemas"]["DeviceType"];
type DeviceOs = components["schemas"]["DeviceOs"];
type DeviceBrowser = components["schemas"]["DeviceBrowser"];
type SignInMethod = components["schemas"]["SignInMethod"];
type SignInApp = components["schemas"]["SignInApp"];

export const DEVICE_TYPE_LABELS: Record<DeviceType, string> = {
  Desktop: "Desktop",
  Mobile: "Mobile",
  Tablet: "Tablet",
  Bot: "Bot or script",
  Unknown: "Unknown",
};

export const OS_LABELS: Record<DeviceOs, string> = {
  Windows: "Windows",
  MacOs: "macOS",
  Ios: "iOS",
  Android: "Android",
  Linux: "Linux",
  ChromeOs: "ChromeOS",
  Other: "Other",
};

export const BROWSER_LABELS: Record<DeviceBrowser, string> = {
  Chrome: "Chrome",
  Edge: "Edge",
  Safari: "Safari",
  Firefox: "Firefox",
  Other: "Other",
};

export const METHOD_LABELS: Record<SignInMethod, string> = {
  Google: "Google",
  Microsoft: "Microsoft",
  Register: "Sign-up",
  InviteAccept: "Invite accepted",
  DevLogin: "Dev login",
  IntegratorExchange: "Integrator",
  EmailCode: "Email code",
};

export const APP_LABELS: Record<SignInApp, string> = {
  Portal: "Portal",
  Sandbox: "Sandbox",
  Integrator: "Integrator app",
  Direct: "Direct to API",
};

const regionNames = new Intl.DisplayNames(["en-GB"], { type: "region" });

export function countryLabel(code: string | null | undefined): string {
  if (!code) return "Unknown";
  try {
    return regionNames.of(code) ?? code;
  } catch {
    return code;
  }
}

/** "St Albans, United Kingdom", or whatever part is known. */
export function locationLabel(city: string | null | undefined, country: string | null | undefined): string | null {
  if (!city && !country) return null;
  return [city, country ? countryLabel(country) : null].filter(Boolean).join(", ");
}

export function deviceLabel(
  type: DeviceType | null | undefined,
  os: DeviceOs | null | undefined,
  browser: DeviceBrowser | null | undefined,
): string | null {
  if (!type) return null;
  const parts = [os && os !== "Other" ? OS_LABELS[os] : null, browser && browser !== "Other" ? BROWSER_LABELS[browser] : null];
  const detail = parts.filter(Boolean).join(" · ");
  return detail ? `${DEVICE_TYPE_LABELS[type]} (${detail})` : DEVICE_TYPE_LABELS[type];
}

export function isoDaysAgo(days: number): string {
  const date = new Date();
  date.setUTCDate(date.getUTCDate() - days);
  return date.toISOString().slice(0, 10);
}
